import { Link } from 'react-router-dom';

const KOFI_USERNAME = 'reemifai';
const KOFI_ENABLED = true; // Set to false to hide donation button

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] border-t border-white/10 mt-16">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-12 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Left: Logo & Copyright */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <Link to="/" className="flex items-center">
              <img
                src="/logo-banner.png"
                alt="CineVault"
                className="h-8 w-auto opacity-80 hover:opacity-100 transition-opacity"
              />
            </Link>
            <p className="text-gray-500 text-sm">
              {currentYear} CineVault. For entertainment purposes only.
            </p>
          </div>

          {/* Center: Links */}
          <div className="flex gap-6 text-sm text-gray-400">
            <Link to="/" className="hover:text-white transition-colors">
              Home
            </Link>
            <Link to="/browse/movie" className="hover:text-white transition-colors">
              Movies
            </Link>
            <Link to="/browse/tv" className="hover:text-white transition-colors">
              TV Shows
            </Link>
            <Link to="/anime" className="hover:text-white transition-colors">
              Anime
            </Link>
            <Link to="/discover" className="hover:text-white transition-colors">
              Discover
            </Link>
          </div>

          {/* Right: Support Button */}
          {KOFI_ENABLED && (
            <div className="flex items-center gap-3">
              <span className="text-gray-500 text-sm hidden sm:inline">
                Enjoying CineVault?
              </span>
              <a
                href={`https://ko-fi.com/${KOFI_USERNAME}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 bg-[#FF5E5B] hover:bg-[#ff4744] text-white text-sm font-medium rounded-lg transition-colors"
              >
                <svg
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M23.881 8.948c-.773-4.085-4.859-4.593-4.859-4.593H.723c-.604 0-.679.798-.679.798s-.082 7.324-.022 11.822c.164 2.424 2.586 2.672 2.586 2.672s8.267-.023 11.966-.049c2.438-.426 2.683-2.566 2.658-3.734 4.352.24 7.422-2.831 6.649-6.916zm-11.062 3.511c-1.246 1.453-4.011 3.976-4.011 3.976s-.121.119-.31.023c-.076-.057-.108-.09-.108-.09-.443-.441-3.368-3.049-4.034-3.954-.709-.965-1.041-2.7-.091-3.71.951-1.01 3.005-1.086 4.363.407 0 0 1.565-1.782 3.468-.963 1.904.82 1.832 3.011.723 4.311zm6.173.478c-.928.116-1.682.028-1.682.028V7.284h1.77s1.971.551 1.971 2.638c0 1.913-.985 2.667-2.059 3.015z" />
                </svg>
                Support Us
              </a>
            </div>
          )}
        </div>


        {/* The Constellation */}
        <div className="mt-6 pt-6 border-t border-white/5">
          <p className="text-gray-600 text-xs text-center mb-4">The Constellation</p>
          <div className="flex flex-wrap justify-center gap-6 text-xs">
            <a href="https://reemifai.org" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-emerald-400 transition-colors flex items-center gap-1">
              <span>🎬</span> ReemifAI
            </a>
            <a href="https://grove.reemifai.org" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-green-400 transition-colors flex items-center gap-1">
              <span>🌱</span> Grove
            </a>
            <a href="https://honeydew.reemifai.org" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-amber-400 transition-colors flex items-center gap-1">
              <span>🍯</span> Honeydew
            </a>
          </div>
        </div>

        {/* Bottom: Disclaimer */}
        <div className="mt-6 pt-6 border-t border-white/5 text-center space-y-3">
          <p className="text-gray-600 text-xs max-w-2xl mx-auto">
            This site does not store any files on our server, we only linked to the media which is
            hosted on 3rd party services. For educational and entertainment purposes only.
          </p>
          <p className="text-[10px] tracking-[0.28em] uppercase text-emerald-300/30">
            L = (O &gt; I) + P + ¬F &nbsp;·&nbsp; WE = 1
          </p>
        </div>
      </div>
    </footer>
  );
}
